import { useCallback, useEffect, useState } from "react";
import {
  getHealthProfile,
  HealthProfileSuccessResponseData,
} from "../../../services/core-api-adapter";

export default function useGetHealthProfile() {
  const [healthProfile, setHealthProfile] =
    useState<HealthProfileSuccessResponseData | null>(null);
  const [healthProfileFetchError, setHealthProfileFetchError] = useState(false);
  const [isHealthProfileLoading, setIsHealthProfileLoading] = useState(true);

  const refetch = useCallback(() => {
    setIsHealthProfileLoading(true);
    getHealthProfile()
      .then((res) => {
        if (res && "items" in res) {
          setHealthProfile(res);
          setHealthProfileFetchError(false);
        } else {
          setHealthProfileFetchError(true);
          setHealthProfile(null);
        }
      })
      .catch(() => {
        setHealthProfileFetchError(true);
        setHealthProfile(null);
      })
      .finally(() => {
        setIsHealthProfileLoading(false);
      });
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setIsHealthProfileLoading(true);
    getHealthProfile({ signal: controller.signal })
      .then((res) => {
        if (res && "items" in res) {
          setHealthProfile(res as HealthProfileSuccessResponseData);
          setHealthProfileFetchError(false);
        } else {
          setHealthProfileFetchError(true);
          setHealthProfile(null);
        }
      })
      .catch(() => {
        if (controller.signal.aborted === false) {
          setHealthProfileFetchError(true);
          setHealthProfile(null);
        }
      })
      .finally(() => {
        setIsHealthProfileLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, []);

  return {
    healthProfile,
    healthProfileFetchError,
    isHealthProfileLoading,
    refetch,
  };
}
